<p>add-attendance works!</p>
